/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const EnumHelper = (data: any = {}) => {
  return Object.keys(data).map((value) => ({
    id: data[value],
    name: value
      .toLowerCase()
      .replaceAll("_", " ")
      .replace(/\b[a-z]/g, (text) => text.toUpperCase()),
  }));
};
export const SchoolEventTypeEnum = {
  GENERAL: 1,
  WEBINAR: 2,
};
export const SchoolEventTargetEnum = {
  ALL: 1,
  CANDIDATE: 2,
  COMPANY: 3,
};
export const SchoolTypeLevelEnum = {
  UNIVERSITY: 1,
  HIGH_SCHOOL: 2,
};
export const SchoolTemplateButtonTypeEnum = {
  SHARP: 1,
  ROUND: 2,
  PILL: 3,
};
export const FontTypeEnum = {
  SERIF: 1,
  SANS_SERIF: 2,
  MONOSPACE: 3,
  CURSIVE: 4,
  FANTASY: 5,
};
export const SchoolTemplateSectionTypeEnum = {
  ONE_COLUMN_CONTENT: 1,
  TWO_COLUMN_CONTENT: 2,
  SINGLE_IMAGE: 3,
  IMAGE_SLIDER: 4,
  NEWS: 5,
  EVENTS: 6,
  JOB_POSTINGS: 7,
};
export const SchoolTemplateNewsTypeEnum = {
  ADMIN: 1,
  SCHOOL: 2,
};
